export const CheckIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return <svg width="24rem" height="24rem" viewBox="0 0 24 24" fill="none" {...props}>
        <path fillRule="evenodd" clipRule="evenodd" d="M18.0896 5.18975C14.5274 1.6275 8.75182 1.6275 5.18957 5.18975C1.62732 8.75201 1.62732 14.5276 5.18957 18.0898L4.45938 18.82C0.49385 14.8545 0.49385 8.42509 4.45938 4.45956C8.42491 0.494033 14.8543 0.494033 18.8198 4.45956L18.0896 5.18975Z" fill="url(#paint0_linear_6679_5)" />
        <path fillRule="evenodd" clipRule="evenodd" d="M5.18942 18.0899C8.75167 21.6521 14.5272 21.6521 18.0895 18.0899C21.6517 14.5276 21.6517 8.75207 18.0895 5.18982L18.8197 4.45963C22.7852 8.42515 22.7852 14.8545 18.8197 18.8201C14.8541 22.7856 8.42476 22.7856 4.45923 18.8201L5.18942 18.0899Z" fill="url(#paint1_linear_6679_5)" />
        <path d="M5.5 10L9.36948 13.8695C9.98185 14.4818 10.9841 14.4499 11.5562 13.7998L21.5 2.5" stroke="url(#paint2_linear_6679_5)" strokeWidth="2" />
        <defs>
            <linearGradient id="paint0_linear_6679_5" x1="8.23204" y1="20.1587" x2="10.9674" y2="0.981361" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" stopOpacity="0" />
                <stop offset="1" stopColor="white" />
            </linearGradient>
            <linearGradient id="paint1_linear_6679_5" x1="15.047" y1="3.12094" x2="12.3211" y2="22.2324" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" stopOpacity="0" />
                <stop offset="1" stopColor="white" />
            </linearGradient>
            <linearGradient id="paint2_linear_6679_5" x1="21.5" y1="2.5" x2="7.5" y2="16" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="1" stopColor="#4F4F4F" />
            </linearGradient>
        </defs>
    </svg>

}